const translations = {
  fr: {
    translation: {
      modal: {
        close: "Fermer",
      },
      header: {
        poweredBy: "Distribué par",
        help: "Aide",
        contact: "Contact",
        bookJourney: "Réserver un trajet",
        home: "Accueil",
        connect: "Se connecter",
      },
      footer: {
        poweredBy: "Distribué par",
        privacyPolicy: "Confidentialité",
        legalNotice: "Mentions légales",
        termsAndConditions: "CGV",
      },
      sessionExpired: "Votre session a expiré. Veuillez vous reconnecter.",
      profileMenu: {
        account: "Mon compte",
        logout: "Déconnexion",
        settings: "Paramètres",
        adminPanel: "Administration",
        bookings: "Mes réservations",
      },
      buildingInProgress: {
        oopsMessage: "Oups ! Cette page est en construction.",
        workMessage: "Nous travaillons dur ! 🛠️",
        disclaimer:
          "Désolé pour le désagrément. Nous vous promettons que cela en vaudra la peine !",
      },
      admin: {
        reservations: "Réservations",
        search: "Rechercher",
        adminZone: "Zone Admin",
        agencyManagement: "Gestion des agences",
        caisseManagement: "Gestion des caisses",
        dapManagement: "Gestion des DAPs",
        userManagement: "Gestion des utilisateurs",
        errorFields: "Un ou plusieurs champs sont incorrects",
        user: {
          userManagement: "Liste des utilisateurs",
          addTravelAgentOrCaisseAssociate:
            "Ajouter un agent de voyage ou un collaborateur caisse",
          addCaisseAssociate: "Ajouter un collaborateur caisse",
          userUpdated: "Utilisateur mis à jour",
        },
        dap: {
          dapManagement: "Gestion des DAPs",
          companions: "Accompagnant(s)",
          import: {
            noFileSelected: "Aucun fichier sélectionné",
            modalTitle: "Importer un fichier de DAPs",
            fileIconAlt: "Icône de fichier",
            uploadProgress: "{{sent}} sur {{total}}",
            uploadPercentage: "Téléchargé à {{percent}}%",
            dragDropInstruction:
              "Faites glisser ici un fichier csv, xls ou xlsx",
            or: "ou",
            selectFile: "Sélectionner un fichier",
            selectAnotherFile: "Sélectionner un autre fichier",
            uploadError: "Erreur de téléchargement.",
            uploadComplete: "Le fichier a été téléchargé.",
            uploadCount: "{{count}} lignes traitées :",
            uploadCompleteWithErrors:
              "Le fichier a été téléchargé avec {{count}} ligne(s) en erreur.",
            uploadSuccess: "✅ {{count}} importées avec succès ",
            uploadUpdated: "🔄 {{count}} mises à jour",
            uploadIgnored:
              "⚠️ {{count}} ignorées (voyage dans le panier ou DAP d'une autre agence)",
            uploadErrors: "❌ {{count}} en erreur",
            uploading: "Chargement du fichier ...",
            cancel: "Annuler",
            uploadErrorLine: "Ligne n° {{count}}",
          },
          journeysBooked: {
            max: "Le nombre de trajets effectués ne peut pas dépasser le nombre de trajet max.",
            min: "Le nombre de trajets effectués doit être suppérieur à zéro",
            required: "Le nombre de trajets effectués est requis",
          },
        },
        agency: {
          agencyManagement: "Gestion des agences",
          agencyOnboarding: "Déclaration d'une agence",
          agencyConfigSelection: "Sélection de la configuration agence",
          agencyConfigSelect: "Sélectionner de la configuration agence",
          agencyAlias: "Alias de l'agence",
          agencyName: "Nom de l'agence sur la plateforme TSAM",
          disableAgency: "Désactiver l'agence {{agency}}",
          disableAgencyText:
            "Vous vous apprêtez à désactiver l'agence {{agency}}. Aucune réservation ne sera possible via cette agence. Êtes-vous sûr de vouloir continuer?",
          instanceUrl: "Url de l'instance the Treep API",
          oauthUrl: "Url de l'instance du serveur d'authentification",
          clientSecret: "Clé secrète",
          clientId: "Client Id",
          onboardingSuccess: "L'agence a bien été déclarée",
        },
        caisse: {
          code: {
            required: "Le code est requis",
            searchPlaceholder: "Saisissez le nom de votre caisse",
          },
          agencyConfiguration: {
            label: "Configuration agence",
            required: "La configuration de l'agence est requise",
            searchPlaceholder: "Saisissez le nom de votre agence",
          },
          trainStationRadius: {
            header: "Rayon (km) gare",
            label:
              "Rayon de recherche des gares autour de l'origine (max 200km)",
            required: "Le rayon de recherche de gare est requis",
          },
          airportRadius: {
            header: "Rayon (km) aéroport",
            label:
              "Rayon de recherche des aéroports autour de l'origine (max 200km)",
            required: "Le rayon de recherche d'aéroport est requis",
          },
          assistedTrainAgencyFees: {
            header: "Frais train assistés (c€)",
            label:
              "Frais d'agence train quand un agent réserve pour le compte d'un bénéficiaire, en centimes d'euro (0 = tarif self-service)",
          },
          assistedPlaneAgencyFees: {
            header: "Frais avion assistés (c€)",
            label:
              "Frais d'agence avion quand un agent réserve pour le compte d'un bénéficiaire, en centimes d'euro (0 = tarif self-service)",
          },
          assistedAgencyFeesVat: {
            header: "TVA frais assistés (%)",
            label:
              "Taux de TVA appliqué aux frais d'agence assistés, en pourcentage (vide = taux standard)",
            range: "Le taux de TVA doit être compris entre 0 et 100",
          },
          trainFlexibility: "Flexibilité train",
          planeFlexibility: "Flexibilité avion",
          caisseManagement: "Gestion des caisses",
          caisseOnboarding: "Ajouter une caisse",
          noFlex: "No flex",
          semiFlex: "Semi flex",
          fullFlex: "Full flex",
          caisseCreated: "La caisse a été créée",
          caisseUpdated: "La caisse a été mise à jour",
        },
      },
      steps: {
        back: "Retour",
        search: "Rechercher",
        select: "Sélectionner",
        check: "Vérifier",
        confirm: "Confirmer",
      },
      booking: {
        dapName: "Nom",
        roundTrip: "Aller-Retour",
        outward: "Aller",
        inward: "Retour",
        title: "Réservez votre trajet",
        ticket_one: "Billet",
        ticket_other: "billets",
        authorizationText:
          "Indiquez votre numéro d’accord pour trouver les conditions et les informations liées au trajet. Vous pourrez ensuite réserver vos pouvez ensuite procéder à la réservation de billets pris en charge par votre sécurité sociale CPAM ou CGSS.",
        authorizationNumber: "Numéro d'accord",
        contactAgency:
          "Votre réservation n'est pas possible en ligne. Veuillez contacter votre agence de voyage pour qu'un opérateur vous assiste.",
        noTravelLeft:
          "Vous avez atteint le nombre maximum de trajet autorisé.\nEn cas d'erreur, veuillez contacter votre agence de voyage pour qu'un opérateur vous assiste.",
        phoneNumber: "Numéro de téléphone :",
        businessHoursTitle: "Heures ouvrées : ",
        businessHoursText: "du lundi au vendredi de 9h à 18h30 heure métropole",
        validatedNumber: "Numéro validé",
        dapComment:
          "Mention portée par la caisse sur cette DAP, à prendre en compte avant de réserver :",
        unknownNumber: "Veuillez vérifier votre numéro d'accord",
        conditions: {
          title: "Conditions",
          placeholder:
            "Saisissez votre numéro d'accord pour consulter vos conditions de prise en charge",
          coverage: "{{percent}}% prise en charge",
          remainingTravels: "Trajets restants",
          remainingTravelsValue: "{{remaining}} sur {{total}}",
          premier: "1ère classe",
          first: "1ere classe",
          second: "2eme classe",
          business: "Classe affaires",
          economy_premium: "Économie premium",
          economy: "Classe économique",
          train: "train",
          plane: "avion",
          boat: "bateau",
          unspecified: "Non spécifié",
          companionNumber: "Nb d'accompagnants",
          maximum: "maximum",
          maxFare: "{{ amount }} max",
        },
        travelCost: "Coût du voyage",
        initialPrice: "Billets",
        agencyFees: "Frais d'agence",
        totalAmount: "Total",
        coveredAmount: "Pris en charge par votre caisse ({{percentage}} %)",
        paidAmount: "Payé par vous ({{percentage}} %)",
        yourRefund: "Votre remboursement",
        amountYouPaid: "Montant que vous avez payé",
        yourAgencyFeesShare:
          "Votre part des frais d'agence ({{percentage}} % de {{fees}})",
        yourRefundAmount: "Remboursé sur votre carte",
        refundExplanation:
          "Les billets sont remboursés intégralement. Les frais d'agence ne sont pas remboursables, votre part est donc déduite.",
        noRefundFullyCovered:
          "Votre caisse a pris en charge la totalité du voyage. Rien ne vous a été facturé, il n'y a donc rien à vous rembourser.",
        exchange: {
          title: "Echangez votre trajet",
          subtitle:
            "Consultez les conditions et modalités d'échange de votre billet de train, puis procédez à la modification de vos billets pris en charge par votre sécurité sociale.",
          tripToExchange: "Trajet à échanger",
          exchange: "Echange",
        },
        noExchange: {
          title: "Modification",
          text: "La modification de ce trajet n'est pas possible en ligne. Veuillez contacter votre agence de voyage <strong>{{agencyName}}</strong> pour qu'un opérateur vous assiste.",
          phoneNumber: "Numero téléphone",
          workingHours: "Heures ouvrées",
        },
        warning: {
          title: "Attention - Modification en cours",
          text: "Vous êtes actuellement en train de modifier votre billet de train. Si vous quittez cette page, vous perdrez votre avancée. Souhaitez-vous vraiment abandonner vos modifications ?",
          confirm: "Valider",
          cancel: "Annuler",
        },
      },
      results: {
        availableOffers: "Offres disponibles",
        confirmTravel: "Choisir ce trajet",
        fareConditions: "conditions tarifaires",
        secondClass: "2nd",
        firstClass: "1st",
        secondClassLong: "Seconde",
        firstClassLong: "Première",
        unavailable: "Indispo.",
        startingFrom: "à partir de",
        hourAbbreviation: "h",
        dayAbbreviation: "j",
        connections: "corresp.",
        returnList: "Retour à la liste",
        previousTrains: "Afficher les trains précédents",
        previousFlights: "Afficher les vols précédents",
        nextTrains: "Afficher les trains suivants",
        nextFlights: "Afficher les vols suivants",
        sortAndFilter: "Trier et filtrer",
        seeDetails: "Voir les détails",
        seeLess: "Voir moins",
        FULL_FLEX: "Full-flex",
        NO_FLEX: "No-Flex",
        SEMI_FLEX: "Semi-Flex",
        UNSPECIFIED: "",
        flexibility: "Flexibilité",
        directConnection: "Trajet direct",
        connectionsLong: "Correspondances",
        sortBy: "Trier par",
        price: "Prix",
        time: "Heure",
        duration: "Durée",
        lowestEmissions: "Le moins émissif",
        coveredAmount: "Montant pris en charge",
        initialPrice: "Prix initial",
        economy: "Éco.",
        economyPremium: "Éco. premium",
        business: "Business",
        noSolutions:
          "Aucun {{transport}} n'est disponible pour le moment.<br/>Veuillez modifier vos critères de recherche et choisir une gare ou un aéroport spécifique. Si le problème persiste, veuillez contacter votre agence de voyage pour qu'un opérateur vous assiste.",
        agencyInfos:
          "Numéro de téléphone : {{phone}}<br/>Heures ouvrées : {{openHours}}",
        freePlacement: "Placement libre",
        coach: "Coach",
        seat: "Siège",
        offlineText:
          "Le tarif sélectionné n’est pas autorisé par votre caisse.",
        priceDifference: "Différence tarifaire",
        exchangeFees: "Montant des frais d'échange",
      },
      recap: {
        modifyTravel: "Modifier ce trajet",
        addToCart: "Ajouter au panier",
        processingTitle: "Ajout au panier en cours",
        processingText:
          "Cette opération peut prendre jusqu'à quelques minutes. Merci de ne pas fermer cette page, ni de la recharger ou de revenir en arrière tant que l'ajout n'est pas terminé.",
        dueAfterCoverage: "Total après prise en charge",
        optionOuigo: "Options supplémentaires",
      },
      cart: {
        routeOf: "Trajet du",
        toThe: "au",
        guaranteedUpTo: "Option jusqu'au",
        at: "à",
        hoursMinutesSeparator: "h",
        deleteTravel: "Supprimer ce trajet",
        myCart: "Mon panier",
        emptyCart: "Vider le panier",
        addTrip: "Ajouter un trajet",
        payTrip: "Payer ce trajet",
        confirmTrip: "Confirmer ce trajet",
        outward: "Aller",
        return: "Retour",
        to: "à",
        totalTravel: "Reste à charge",
        initialPrice: "Coût total",
        coveredAmount: "Montant pris en charge",
        agencyFees: "Frais d'agence",
        noItems: "Votre panier est vide",
        deleteConfirmation: "Voulez-vous vraiment vider votre panier ?",
        releaseConfirmation:
          "Voulez-vous vraiment retirer ce trajet du panier ?",
      },
      confirmation: {
        title: "Confirmation",
        exchangeTitle: "Confirmation de l’échange",
        paymentTitle: "Confirmation du paiement",
        successMessage: "Votre réservation a été effectuée avec succès",
        exchangeSuccessMessage:
          "Succès : Votre trajet est bien modifié. Les nouveaux billets vous seront envoyés par e-mail.",
        paymentSuccessMessage:
          "Succès : Votre paiement a été effectué avec succès. D'ici quelques minutes, vous recevrez un mail de confirmation pour ce voyage.",
        errorMessage:
          "Une erreur est survenue et la réservation de votre voyage n'a pas pu aboutir. Veuillez réessayer. Si l'erreur persiste, veuillez contacter votre agence.",
        backHome: "Retour à la page d'accueil",
        errorTitle: "Erreur",
        confirmBooking: "Confirmer la réservation",
        viewBookings: "Voir mes réservations",
        bookNewTrip: "Réserver un nouveau trajet",
      },
      travelStatus: {
        UNSPECIFIED: "Non spécifié",
        PRE_BOOKED: "Pré-réservé",
        BOOKED: "Réservé",
        UPCOMING: "À venir",
        IN_PROGRESS: "En cours",
        BOOKING_IN_PROGRESS: "En cours de réservation",
        COMPLETED: "Terminé",
        CANCELLED: "Annulé",
      },
      status: "Statut",
      active: "Actif",
      conform: "Conforme",
      notConform: "Non conforme",
      inactive: "Inactif",
      number: "N° d'accord",
      email: "Email",
      lastName: "Nom",
      firstName: "Prénom",
      caisseId: "Caisse",
      name: "Nom",
      creationDate: "Date de création",
      associatedCaisses: "Caisses associées",
      billingClientName: "Nom du client the Treep à facturer",
      treepRecapPhoneNumber: "Numéro de téléphone sur le Treep recap",
      outOfPocketExpense: "Reste à charge",
      treepRecap: "Treep Recap",
      contactEmail: "E-mail contact",
      logo: "Logo",
      instanceUrl: "Url instance",
      type: "Type",
      tauxPec: "Taux PEC",
      origin: "Origine",
      destination: "Destination",
      transportations: "Transports autorisés",
      companions: "Nb accompagnant(s)",
      maxJourneys: "Nb trajets max.",
      journeysBooked: "Nb trajets effectués",
      trainCabinClass: "Classe max. train",
      planeCabinClass: "Classe max. avion",
      comments: "Commentaires",
      error: "Erreur",
      train: "Train",
      plane: "Avion",
      boat: "Bateau",
      unspecified: "Non spécifié",
      all: "Toutes",
      import: "Importer",
      ok: "Ok",
      back: "Retour",
      class: {
        first: "Première",
        second: "Seconde",
        business: "Business",
        economypremium: "Economique premium",
        economy: "Economique",
      },
      edit: "Editer",
      modify: "Modifier",
      save: "Sauvegarder",
      online: "online",
      offline: "offline",
      details: "Voir les détails",
      comment: "Commentaire",
      userBookings: {
        title: "Mes réservations",
        currentTravels: "Trajets en cours",
        pastTravels: "Trajets passés",
        noCurrentTravels: "Vous n'avez pas de trajets en cours",
        noPastTravels: "Vous n'avez pas de trajets passés",
        sortAndFilter: "Trier et filtrer",
        place: "Lieu",
        status: "Statut",
        dates: "Dates",
        cancel: "Annuler",
        exchangeRequest: "Sélectionner le trajet à échanger",
        exchangeOutward: "Échanger l'aller",
        exchangeInward: "Échanger le retour",
        fixedChangeFee: "Frais de modification fixe",
        variableChangeFee: "Frais de modification variable",
        changeableUntil: "Modifiable jusqu'au {{date}}",
        cancellation: "Annulation",
        sucessfulCancellation: "Votre trajet a bien été annulé",
        errors: {
          cancellation:
            "L'annulation de ce trajet n'est pas possible en ligne. Veuillez contacter votre agence de voyage <strong>{{agency}}</strong> pour qu'un opérateur vous assiste.\n\nNuméro de téléphone: \n<strong>{{phone}}</strong>\nHeures ouvrées: <strong>{{hours}}</strong>",
        },
        offlineTitle: "Redirection vers le parcours offline",
        offlineText:
          "Le coût total de votre échange (frais d'échange + nouveau billet) est supérieur au prix initial de votre billet. Ce type de modification n'est pas possible en ligne.",
        offlineText1:
          "Veuillez contacter votre agence de voyage <strong>{{agencyName}}</strong> pour qu'un opérateur vous assiste.",
        offlinePhoneNumber: " Numéro de téléphone",
        openHour: "Heures ouvrées",
        offlineClose: "Fermer",
        offlineBackToHome: "Retour à l'accueil",
        paidPrice: "Montant payé",
        refundPrice: "Montant remboursé",
        initialPrice: "Prix initial",
        amountCovered: "Montant pris en charge",
        agencyFees: "Montant des frais d'agence",
        refundPriceToCaisse: "Montant remboursé à la caisse",
        refundedTotal: "Montant total remboursé",
        customerRefundFailed:
          "Votre voyage a bien été annulé mais votre paiement n'a pas pu être remboursé. Veuillez contacter votre agence {{agency}} au {{phone}} ({{hours}}) pour obtenir votre remboursement.",
      },
      user: {
        role: {
          admin: "Administrateur",
          travelAgent: "Agent de voyage",
          caisseAssociate: "Collaborateur de caisse",
          user: "Utilisateur",
          createUser: "Ajouter un utilisateur",
        },
      },
      settings: {
        gdpr: {
          title: "CGU/CGV",
          cguAccessText: "Accès",
          cguAccessLink: "CGU/CGV",
          deleteAccount: "Je supprime mon compte",
          deleteAccountConfirmation: {
            title: "Supprimer mon compte",
            text: "Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible.",
            confirm: "Confirmer",
            cancel: "Annuler",
          },
          deleteAccountSuccess: "Votre compte a bien été supprimé.",
          forgetMe: "Je supprime mon compte et exerce mon droit à l'oubli",
        },
      },
      role: "Role",
      confirm: "Confirmer",
      cancel: "Annuler",
      agency: "Agence",
      caisse: "Caisse",
      caisses: "Caisses",
      form: {
        fieldRequired: "Champs requis",
        email: {
          placeholder: "exemple@domaine.com",
          invalid: "Email invalide",
          required: "Email requis",
        },
        firstName: {
          placeholder: "Votre prénom ici",
          required: "Prénom requis",
        },
        lastName: {
          placeholder: "Entrez votre nom de famille",
          required: "Nom requis",
        },
        agency: {
          required: "Agence requise",
        },
        caisses: {
          required: "Au moins une caisse est requise",
        },
        phone: {
          required: "Numéro de téléphone requis",
          invalid: "Le numéro de téléphone n'est pas valide",
        },
        departureDate: {
          required: "La date de départ est requise",
        },
        returnDate: {
          required: "La date de retour est requise",
          minGap: "Le retour doit être au moins 1 heure après le départ",
        },
        origin: {
          required: "Veuillez sélectionner un lieu de départ",
        },
        birthDate: {
          placeholder: "JJ/MM/AAAA",
          required: "La date de naissance est requise",
          invalid: "La date de naissance n'est pas valide",
        },
        gender: {
          label: "Genre",
          required: "Le genre est requis",
          male: "Homme",
          female: "Femme",
          nonBinary: "Non-binaire",
        },
        accreditation: {
          placeholder: "Saisissez le numéro d'accréditation",
          invalid: "Le numéro d'accréditation n'est pas valide",
        },
      },
      selectPlaceholder: "Sélectionner...",
      traits: {
        email: "Email",
        firstname: "Prénom",
        lastname: "Nom",
      },
      connect: "Se connecter",
      code: "Code",
      travel: "Trajet",
      from: "De",
      to: "Vers",
      add: "Ajouter",
      search: {
        travelFormInfos: {
          incorrectInfo:
            "Vous avez constaté une information incorrecte ? Veuillez contacter votre agence.",
          moreLuggages:
            "Si vous souhaitez ajouter des bagages supplémentaires, si vous nécessitez un transport en civière ou l'ajout d'équipement lourd, si vous nécessitez un sur classement ou l'ajout d'un siège supplémentaire sur avis médical, veuillez prendre contact avec votre agence de voyage pour réserver votre voyage.",
          connections:
            "Si vous souhaitez réaliser des correspondances prenant en charge différents modes de transport, veuillez prendre contact avec votre agence de voyage pour réserver votre voyage.",
        },
        originDestination: "Origine et destination",
        departureReturn: "Départ et retour",
        passengers: "Passager(s)",
        selectLocation: "Sélectionner un lieu",
        destinationTooltip:
          "Informations non modifiables, l'aéroport ou gare le plus pertinent sera proposé",
        departureAt: "Départ le",
        returnAt: "Retour le",
        leaveAt: "Partir à",
        arriveAt: "Arriver à",
        panelPlaceholder: "Cliquer sur un champ pour voir les options",
        search: "Rechercher",
        passenger: {
          mainPassenger: "Bénéficiaire",
          personalInfo: {
            heading: "Informations personnelles",
            info: "Les champs étoilées sont obligatoires.",
          },
          info: "Vous avez constaté une information incorrecte ? Veuillez contacter votre agence.Le bénéficiaire est la personne concernée par le DAP",
          name: "Nom",
          lastname: "Nom",
          firstname: "Prénom",
          email: "Email",
          birthdate: "Date de naissance",
          phone: "Téléphone",
          residentCorsicaRate: "Tarif Résident Corse",
          residentCorsicaRateLink: "Accréditation Résident Corse",
          accreditationRequirement:
            "Pour bénéficier de ces tarifs à compter du 1er mars 2021, vous devez disposer d'un numéro d'accréditation valide. Celui-ci est attribué en ligne après justification d'une résidence fiscale principale et effective en Corse. Plus d'informations :",
          disability: {
            heading: "Je suis en situation de handicap",
            disability: "Handicap",
            wheelchair: {
              type: "Fauteuil roulant",
              dimensions: "Dimensions plié (en cm)",
              width: "Largeur",
              height: "Hauteur",
              length: "Longueur",
              weight: "Poids (en kg)",
              wheelsThickness: "Epaisseur des roues (en cm)",
            },
          },
          companion: {
            heading: "Je suis accompagnant PSH",
            typePlaceholder: "Type d’accompagnant",
            required: "Veuillez sélectionner un type d'accompagnant",
            placeholder: "Type d'accompagnant",
            unspecified: "Accompagnant (non guide)",
            disability_80_percent:
              "Guide PSH tarif réduit : CMI invalidité ou carte d'invalidité française sans mention, ou avec la mention « station debout pénible » ou « canne blanche »",
            need_third_person:
              "Guide PSH gratuit - CMI invalidité ou carte d'invalidité française avec mention « besoin d'accompagnement » ou « tierce personne » (sauf exceptions sur trajets internationaux)",
            blindness_green_star:
              "Guide PSH aveugle gratuit - CMI invalidité ou carte d'invalidité française avec mention « Cécité » ou « Étoile verte » (sauf exceptions sur trajets internationaux)",
          },
          accreditation: "N° Accréditation",
          isCompanion: "Je suis un accompagnant PMR",
          card: {
            heading: "Carte de fidélité et réduction",
            add: "Ajouter une carte de voyage",
            edit: "Modifier une carte de voyage",
            type: {
              label: "Type de carte",
              required: "Type de carte requis",
            },
            number: {
              label: "Numéro de carte",
              required: "Numéro de carte requis",
            },
            effectiveDate: {
              label: "Date d'effet",
              required: "Date d'effet requise",
            },

            expirationDate: {
              label: "Date d'expiration",
              required: "Date d'expiration requise",
              minDate: "La carte est expirée",
            },
            checkboxConsent:
              "En cochant cette case, j'accepte que les informations saisies soient exploitées dans le cadre de mon déplacement.",
            privacyPolicyLink: "Consultez notre politique de confidentialité",
            checkboxAccuracy:
              "En cochant cette case, je certifie l'exactitude des données enregistrées et je suis responsable des conséquences d'une mauvaise saisie de ces dernières.",
            expireAt: "Expire le",
            travelCard: "Carte de voyage",
          },
          nonBinaryDisclaimer:
            "Nous respectons pleinement votre identité de genre. Cependant, certains de nos partenaires de transport exigent une sélection binaire (Masculin/Féminin) pour des raisons administratives.<br>Afin de finaliser votre réservation, nous vous invitons à choisir l'option qui vous convient le mieux. Cette sélection est uniquement utilisée à des fins de billetterie et n'a aucun impact sur la reconnaissance de votre identité.<br>Nous comprenons que cela puisse être contraignant et nous continuons à travailler avec nos partenaires pour offrir plus d'inclusivité à l'avenir. Merci de votre compréhension.",
        },
        additionalPassengers: {
          companions: "Accompagnant(s)",
          info: "Si les accompagnants sont différents à l'aller et au retour, ou si leurs dates de voyages diffèrent des vôtres, merci de prendre contact avec votre agence pour la réservation de votre voyage.",
          addCompanion: "Ajouter un accompagnant",
          editCompanion: "Modifier un accompagnant",
          maxCompanion: "({{number}} accompagnants max.)",
          maxCompanionTooltip:
            "Pour ajouter plus de {{number}} accompagnants, veuillez contacter votre agence de voyage.",
        },
        outward: "Aller",
        return: "Retour",
        errors: {
          moreOffers: "Impossible de récupérer des offres supplémentaires",
          overlapping: {
            title: "Réservation existante détectée",
            exact:
              "Vous disposez déjà d'une réservation à ces dates. Nous vous recommandons de modifier les dates de votre recherche.\nSi besoin, vous pouvez contacter votre agence de voyage <strong>{{agency}}</strong> pour modifier votre réservation existante ou pour toute autre demande spécifique. Vous pouvez la contacter pour qu’un opérateur vous assiste.\n\nNuméro de téléphone : <strong>{{phone}}</strong>\nHeures ouvrées : <strong>{{hours}}</strong>",
            month:
              "Vous avez déjà réservé un voyage sur cette période. Nous vous recommandons de vérifier votre réservation existante avant d'effectuer une nouvelle recherche.\nSi vous souhaitez modifier votre voyage ou obtenir des précisions, vous pouvez contacter votre agence de voyage <strong>{{agency}}</strong>. Un opérateur sera disponible pour vous assister.\n\nNuméro de téléphone : \n<strong>{{phone}}</strong>\nHeures ouvrées : <strong>{{hours}}</strong>\n\nVous pouvez poursuivre votre recherche si vous le souhaitez.",
            search: "Lancer la recherche",
          },
        },
        moreMsg:
          "Meilleures offres A/R en tarif public parmi toutes les offres disponibles. Lors de la sélection du retour, si vous bénéficiez de tarifs spéciaux (négociés, ONG...) ils apparaîtront. Vous pourrez également choisir parmi toutes les offres disponibles (tarif, flexibilité, bagages).",
      },
      disability: "Handicap",
      validate: "Valider",
      loader: {
        didYouKnow: "Le saviez-vous ?",
        search:
          "Nous recherchons les meilleurs itinéraires pour aller à {{place}}...",
      },
      genericError: "Une erreur est survenue",
      product: {
        operatedBy: "Opéré par",
        soldBy: "Vendu par",
        connectionTime: "Temps de correspondance",
        cabinClass: "Classe",
        numberShort: "N°",
      },
      home: {
        serviceTitle: "Service Trajet Santé",
        serviceDescription:
          "Vous avez reçu un accord de prise en charge de transport pour soins ? L’Assurance Maladie s’occupe de vos déplacements train, avion ou bateau. Suivez les trois étapes ci-dessous:",
        stepCreateAccount: "Créez votre compte",
        stepConnected: "Vous êtes connecté.e",
        stepDescription1:
          "Cliquez ici pour créer votre compte, ou connectez-vous si vous avez déjà un compte.",
        createAccountBtn: "Créer mon compte",
        stepAuthNumber: "Saisissez votre Nº d'accord",
        numberValidated: "Numéro validé",
        stepDescription2:
          "Saisissez votre numéro d’accord et consultez les détails de votre trajet. Vous pouvez ensuite procéder à la réservation de billets pris en charge par votre sécurité sociale CPAM ou CGSS.",
        findAuthNumberLink:
          "Où trouver mon numéro d'accord de prise en charge ?",
        stepJourneyDetails: "Détails de votre trajet",
        journeyConditionsIntro:
          "Ci après les conditions de prise en charge de votre trajet :",
        bookJourneyBtn: "Je réserve mon trajet",
        facilitatedTransport: "Le transport pour soins facilité",
        facilityDescription1:
          'Vous avez reçu un accord de prise en charge de transport pour soins ? L’Assurance Maladie facilite votre déplacement et vous propose de réserver votre billet de train/avion via son site interne dédié, "Trajet santé de l\'Assurance Maladie" (TSAM).',
        facilityDescription2:
          "Ce service est réservé aux assurés rattachés aux caisses d'assurance maladie des départements suivants : Charente Maritime, Finistère, Corse du sud, Haute Corse, Martinique, Guadeloupe, Guyane Reunion, Mayotte, Var, Gard, Aquitaine, Loire-Atlantique.",
        bookYourJourney: "Réservez votre trajet",
        simpleQuickEconomical: "Simple, rapide et économique",
        simpleDescription1:
          "Réservez votre billet en toute simplicité, au moins 7 jours à l’avance, directement sur ce site internet ou par téléphone (du lundi au vendredi, de 9h à 18h30, heure de métropole / de 4h à 13h30 en Guyane / de 3h à 12h30 aux Antilles / de 11h à 20h30 à La Réunion et Mayotte).\n📞 Appel non surtaxé (coût d’un appel local). N’oubliez pas de vous munir de votre numéro d’accord lors de votre réservation.",
        simpleDescription2:
          "Vous recevez votre billet par mail ou courrier. Vous ne payez pas votre billet ou seulement une partie de celui-ci selon le taux de prise en charge",
        faqTitle: "Questions fréquentes",
        findDapModalTitle: "Où trouver mon numéro d'accord ?",
        findDapModalDescription:
          "Vous pourrez trouver votre numéro d'accord dans le courrier envoyé par l'Assurance Maladie :",
        findDapModalImageAlt: "Exemple de numéro d'accord",
        allAnswersInFAQ: "Toutes les réponses dans notre FAQ",
        helpVideoTitle: "Vous rencontrez des difficultés ?",
        helpVideoDescription:
          "Une vidéo d'aide est disponible pour vous accompagner dans l'utilisation de la plateforme.",
        helpVideoLink: "Voir la vidéo d'aide",
      },
      validation: {
        required: "Ce champ est obligatoire",
      },
      options: {
        title: "Options supplémentaires",
        ouigoflexText:
          "Échangez sans frais votre billet jusqu'à 30 minutes avant le départ de votre train",
        seeConditions: "Voir les conditions",
        ouigoFlex: "OUIGO Flex",
        ouigiflexAdult: "{{price}}/ Adulte",
        ouigiflexChild: "Gratuit pour les enfants",
        luggage: "Bagages supplémentaires",
        luggageDimensions: "Dimensions max 1,3 x 1,3 et 30kg",
        luggageMaximum: "{{price}}/bagage, maximum {{max}}",
        luggageWarning:
          "Réservez dès maintenant vos bagages supplémentaires. Tout bagage non réservé sera facturé 20€ lors du contrôle à quai.",
        foldedBike: "Vélo plié ou démonté mis sous housse",
        foldedBikeDimensions: "Dimensions max 130 x 90 et 30kg",
        foldedBikeMaximum: "{{price}}/vélo, maximum {{max}}",
        nonFoldedBike: "Vélo non démonté",
        nonFoldedBikeWarning:
          "Hors vélos couchés, tricycles, tandems et remorques.",
        nonFoldedBikeMaximum: "{{price}}/vélo, maximum {{max}}",
        additionalCost: "Cout supplémentaire : {{cost}}",
        next: "Suivant",
        passenger: "Passager",
      },
      exchange: {
        exchange: "Échange",
        newTravel: "Nouveau trajet",
        toPay: "Montant à régler",
        priceDifference: "Différence tarifaire",
        exchangeFees: "Montant des frais d'échange",
        agencyFees: "Montant des frais d'agence",
        confirm: "Confirmer l'échange",
        searchForm: {
          departure: "Départ",
        },
      },
      satisfaction: {
        title: "Donnez-nous votre avis sur Trajet Santé Assurance Maladie",
        button: "Répondre au questionnaire",
      },
      placement: {
        title: "Placement",
        noPreference: "Pas de préférence",
        nextRelatives: "Voyager à côté d’un proche",
        trainPlan: "Choisir sur le plan du train",
        preference: "Indiquer les preferences",
        carNumber: "Numéro de voiture",
        placeNumber: "Numéro de place",
        chooseSeat: "Choisir un siège",
        upperDeck: "Etage haut",
        lowerDeck: "Etage bas",
        seat: "Siège",
        next: "Suivant",
        confirm: "Confirmer",
        edit: "Modifier",
        spaceType: "Espace",
        seatDeck: "Salle",
        seatPosition: "Siège",
        searchError: "Souhait de placement pas disponible",
      },

      contact: {
        title: "Contact",
        description:
          "Pensez à consulter régulièrement la rubrique 'Mes réservations' dans votre espace personnel pour suivre l'état de vos demandes.",
        help: "Si vous ne trouvez pas la réponse à votre question dans notre page Aide, n'hésitez pas à contacter votre agence",
        selectCaisse: "Sélectionnez votre caisse",
        phoneTitle: "Par téléphone",
        phoneDescription:
          " Appelez votre agence <strong>{{agencyName}}</strong> au {{phoneNumber}}{{openHours}}",
        chatTitle: "Par chat",
        chatDescription:
          "Posez toutes vos questions à un agent <strong>{{agencyName}}</strong> en cliquant sur le chat en bas à droite de chaque page",
        emailTitle: "Par email",
        emailDescription: "En envoyant un email à <strong>{{email}}</strong>",
        error:
          "Votre caisse d'assurance maladie n'a pas souscrit au service Trajet Santé en ligne.",
        noConnected: "Veuillez vous connecter afin d’accéder à cette page",
      },

      faq: {
        title: "Aide",
        subtitle:
          "Retrouvez ci dessous les règles générales sur la prise en charge des transports",
        questions: [
          {
            question: "Quelles sont les conditions de prise en charge ?",
            answer: `Pour réserver vos billets de transport (train, avion, bateau dans certaines régions) pris en charge par l'Assurance Maladie via la plateforme dédiée **Service Trajet Santé de l'Assurance Maladie**, vous devez avoir reçu un courrier de votre CPAM/CGSS vous expliquant la procédure. Cette notification comporte un numéro d'accord vous permettant de réaliser vos réservations de billets en ligne.`,
          },
          {
            question: "Quels sont les transports pris en charge sur le site ?",
            answer: `Que vous voyagiez seul(e) ou avec un accompagnant, votre médecin peut prescrire un transport en **avion, bateau ou train**.
        
- Pour les trajets en **avion, bateau ou train supérieurs à 150 km** un accord de prise en charge est nécessaire.

- Le **numéro d'accord** indiqué sur votre notification vous permet de réserver votre billet via le **Service Trajet Santé de l'Assurance Maladie**.
        `,
          },
          {
            question: "Quels moyens de transport puis-je réserver ?",
            answer: `Via le **Service Trajet Santé de l'Assurance Maladie** vous pouvez réserver les modes de transports suivants :
- **Train et avion** : en ligne ou par téléphone.
- **Bateau** : uniquement par téléphone.
        `,
          },
          {
            question:
              "De quoi ai-je besoin pour réserver un billet de transport pris en charge ?",
            answer: `Pour réserver un billet prise en charge, vous avez besoin de votre courrier d'accord de prise en charge transmis par votre CPAM/CGSS, indiquant votre **numéro d'accord**.`,
          },
          {
            question: "Mon billet est-il entièrement pris en charge ?",
            answer: `Lorsque vous utilisez le Service Trajet Santé de  l'Assurance Maladie, vous ne payez pas votre billet ou uniquement une partie de celui-ci selon le taux de prise en charge applicable à votre transport. Votre mutuelle peut rembourser le reste à charge.
| Montant du billet | Taux de prise en charge | Pris en charge par l'Assurance Maladie | Montant à payer |
|-------------------|-------------------------|----------------------------------------|-----------------|
| 100 €             | 100%                    | 100 €                                  | 0 €             |
| 100 €             | 55%                     | 55 €                                   | 45 €            |`,
          },
          {
            question: "Quels sont les critères de prise en charge ?",
            answer: `Les critères de prise en charge sont précisées dans votre courrier d'accord de prise en charge. Ils comprennent :
- Le moyen de transport prescrit.
- Le nombre de trajets.
- La destination.
- Le taux de prise en charge (55% ou 100%).
- Les conditions spécifiques (accompagnant, 1ᵉ classe, cabine bateau).

**Ne sont pas pris en charge via la plateforme :**
- Les options personnelles (repas, cabine de luxe...)
`,
          },
          {
            question: "Prise en charge des transports complémentaires",
            answer:
              "Si vous devez utiliser un **transport en commun**, vous pouvez demander un remboursement via le service [Mes Remboursements Simplifiés](https://www.mrs.beta.gouv.fr/). Le médecin vous remet une prescription médicale autorisant la prise en charge de ces types de transport.",
          },
          {
            question: "Puis-je réserver en ligne tous les types de transport ?",
            answer: `Oui, vous serez guidé(e). Vous pouvez réserver vos billets **aller-retour en train ou avion**. Pour certains cas, il faudra contacter un conseiller de votre agence via la [page Contact](/admin/contact) :
- **Demandes spéciales**.
- **Trajet simple (aller uniquement)**.
- **Réservation de bateau**.`,
          },
          {
            question: "Comment réserver un billet ?",
            answer: `
1. Je m'identifie sur le site.
2. Je saisis mon n° d'accord.
3. Je renseigne les informations passager(s).
4. Je recherche mon billet.
5. Je réserve mon aller-retour.
6. Je paie le reste à charge de mon billet le cas échéant
7. Je reçois mes billets par e-mail.
            `,
          },
          {
            question: "Première connexion ?",
            answer: `
- **Inscrivez-vous** en cliquant sur "Inscription".
- Remplissez les informations demandées (identiques à celles de votre courrier CPAM/CGSS).
- Cliquez sur le lien de validation reçu par e-mail.
- Si vous ne recevez rien, vérifiez vos **SPAM**.
            `,
          },
          {
            question: "Déjà inscrit(e) ?",
            answer: `
- **Connectez-vous** avec votre adresse e-mail et mot de passe.
- En cas d'oubli, cliquez sur "**Mot de passe oublié** ?" et suivez les instructions.            
            `,
          },
          {
            question: "Besoin d'aide ?",
            answer: `Rendez vous sur la page [Contact](/admin/contact)`,
          },
        ],
      },
      passport: {
        heading: "Passeport passager {{index}}",
        mandatoryFields: "Les champs étoilés sont obligatoires.",
        number: "Numéro de passeport",
        numberPlaceholder: "Saisissez votre numéro de passeport",
        issueDate: "Date d'effet (DD/MM/YYYY)",
        issueDatePlaceholder: "DD/MM/YYYY",
        expiryDate: "Date d'expiration (DD/MM/YYYY)",
        expiryDatePlaceholder: "DD/MM/YYYY",
        countryOfIssue: "Pays de délivrance",
        countryPlaceholder: "Choisissez votre pays de délivrance",
        validation: {
          expiryDateMustBeAfterIssueDate:
            "La date d'expiration doit être après la date d'effet",
          expiryDateMustBeInTheFuture:
            "La date d'expiration doit être dans le futur",
        },
      },
      cookies: {
        title: "🍪 Gestion des cookies",
        body: "Ce site utilise un cookie strictement nécessaire pour activer le service de messagerie en ligne. Aucune donnée n’est collectée à des fins publicitaires ou statistiques.",
      },
    },
  },
  en: {
    translation: {
      modal: {
        close: "Close",
      },
      header: {
        poweredBy: "Powered by",
        help: "Help",
        contact: "Contact",
        bookJourney: "Book a journey",
        home: "Home",
        connect: "Connect",
      },
      footer: {
        poweredBy: "Powered by",
        legalNotice: "Legal Notice",
        privacyPolicy: "Privacy Policy",
        termsAndConditions: "Terms and Conditions",
      },
      sessionExpired: "Your session has expired. Please log in again.",
      profileMenu: {
        account: "My account",
        logout: "Logout",
        settings: "Settings",
        adminPanel: "Admin Panel",
        bookings: "My bookings",
      },
      buildingInProgress: {
        oopsMessage: "Oops! This page is under construction.",
        workMessage: "We're hard at work! 🛠️",
        disclaimer:
          "Sorry for the inconvenience. We promise it'll be worth the wait!",
      },
      admin: {
        reservations: "Bookings",
        search: "Search",
        adminZone: "Admin Zone",
        agencyManagement: "Agency Management",
        caisseManagement: "Caisse Management",
        dapManagement: "DAP Management",
        userManagement: "User Management",
        errorFields: "One or more fields are incorrect",
        user: {
          userManagement: "Manage users",
          addTravelAgentOrCaisseAssociate:
            "Add a travel agent or caisse associate",
          addCaisseAssociate: "Add a caisse associate",
          userUpdated: "User updated",
        },
        dap: {
          dapManagement: "DAP Management",
          companions: "Companion(s)",
          import: {
            noFileSelected: "No file selected",
            modalTitle: "Import DAP file",
            fileIconAlt: "File icon",
            uploadProgress: "{{sent}} of {{total}}",
            uploadPercentage: "Uploaded {{percent}}%",
            dragDropInstruction: "Drag and drop a .csv file here",
            or: "or",
            selectFile: "Select a file",
            selectAnotherFile: "Select another file",
            uploadError: "Upload error.",
            uploadComplete: "File has been uploaded.",
            uploadCount: "{{count}} lines processed:",
            uploadCompleteWithErrors:
              "File has been uploaded with {{count}} error line(s).",
            uploadSuccess: "✅ {{count}} successfully imported",
            uploadUpdated: "🔄 {{count}} updated",
            uploadIgnored:
              "⚠️ {{count}} ignored (travel in cart or DAP of another agency)",
            uploadErrors: "❌ {{count}} in errors",
            uploading: "Uploading file...",
            cancel: "Cancel",
            uploadErrorLine: "Line n° {{count}}",
          },
          journeysBooked: {
            max: "The number of booked journeys cannot be greater than the maximum of journeys",
            min: "The number of booked journeys must be greater than zero",
            required: "The number of booked journeys is required",
          },
        },
        agency: {
          agencyManagement: "Agency Management",
          agencyOnboarding: "Agency onboarding",
          agencyConfigSelection: "Agency configuration selection",
          agencyConfigSelect: "Select agency configuration",
          agencyAlias: "Agency alias",
          agencyName: "Agency name on the TSAM platform",
          disableAgency: "Disable agency {{agency}}",
          disableAgencyText:
            "You are about to disable agency {{agency}}. No booking will be possible through this agency. Are you sure you want to continue?",
          instanceUrl: "The Treep API instance URL",
          oauthUrl: "The authentication server instance URL",
          clientSecret: "Client secret",
          clientId: "Client Id",
          onboardingSuccess: "The agency has been successfully registered",
        },
        caisse: {
          code: {
            required: "Code is required",
            searchPlaceholder: "Enter your caisse name",
          },
          agencyConfiguration: {
            label: "Agency configuration",
            required: "Agency configuration is required",
            searchPlaceholder: "Enter your agency name",
          },
          trainStationRadius: {
            header: "Train station radius (km)",
            label:
              "Search radius for train stations around the origin (200km max)",
            required: "Train station radius is required",
          },
          airportRadius: {
            header: "Airport radius (km)",
            label: "Search radius for airports around the origin (200km max)",
            required: "Airport radius is required",
          },
          assistedTrainAgencyFees: {
            header: "Assisted train fees (€ cents)",
            label:
              "Train agency fees when an agent books on behalf of a beneficiary, in euro cents (0 = self-service rate)",
          },
          assistedPlaneAgencyFees: {
            header: "Assisted plane fees (€ cents)",
            label:
              "Plane agency fees when an agent books on behalf of a beneficiary, in euro cents (0 = self-service rate)",
          },
          assistedAgencyFeesVat: {
            header: "Assisted fees VAT (%)",
            label:
              "VAT rate applied to the assisted agency fees, in percent (empty = standard rate)",
            range: "VAT rate must be between 0 and 100",
          },
          trainFlexibility: "Train flexibility",
          planeFlexibility: "Plane flexibility",
          caisseManagement: "Caisse management",
          caisseOnboarding: "Add a caisse",
          noFlex: "No flex",
          semiFlex: "Semi flex",
          fullFlex: "Full flex",
          caisseCreated: "Caisse has been created",
          caisseUpdated: "Caisse has been updated",
        },
      },
      steps: {
        back: "Back",
        search: "Search",
        select: "Select",
        check: "Check",
        confirm: "Confirm",
      },
      booking: {
        dapName: "Name",
        roundTrip: "Round trip",
        outward: "Outward",
        title: "Book your journey",
        ticket_one: "Ticket",
        ticket_other: "tickets",
        authorizationText:
          "Enter your agreement number to find the conditions and information relating to your journey. You can then book tickets covered by your social security CPAM or CGSS.",
        authorizationNumber: "Agreement number",
        contactAgency:
          "Your booking is not possible online. Please contact your travel agency to book a journey. You can call them for assistance.",
        noTravelLeft:
          "You have reached the maximum number of trips allowed.\nIf you believe this is an error, please contact your travel agency so an operator can assist you.",
        phoneNumber: "Phone number:",
        businessHoursTitle: "Business hours:",
        businessHoursText:
          "Monday to Friday from 9:00 AM to 6:30 PM (metropolitan time)",
        validatedNumber: "Validated number",
        dapComment:
          "Note added by the caisse on this DAP — take it into account before booking:",
        unknownNumber: "Please check your agreement number",
        conditions: {
          title: "Conditions",
          placeholder:
            "Enter your agreement number to view your coverage conditions",
          coverage: "{{percent}}% coverage",
          remainingTravels: "Remaining journeys",
          remainingTravelsValue: "{{remaining}} out of {{total}}",
          premier: "First class",
          first: "First class",
          second: "Second class",
          business: "Business class",
          economy_premium: "Premium economy",
          economy: "Economy class",
          train: "train",
          plane: "plane",
          boat: "boat",
          unspecified: "Unspecified",
          companionNumber: "Companion number",
          maximum: "maximum",
          maxFare: "{{ amount }} max",
        },
        travelCost: "Travel cost",
        initialPrice: "Tickets",
        agencyFees: "Agency fees",
        totalAmount: "Total",
        coveredAmount: "Covered by your caisse ({{percentage}}%)",
        paidAmount: "Paid by you ({{percentage}}%)",
        yourRefund: "Your refund",
        amountYouPaid: "Amount you paid",
        yourAgencyFeesShare:
          "Your share of agency fees ({{percentage}}% of {{fees}})",
        yourRefundAmount: "Refunded to your card",
        refundExplanation:
          "Tickets are refunded in full. Agency fees are not refundable, so your share of them is deducted.",
        noRefundFullyCovered:
          "Your caisse covered this trip in full. Nothing was charged to you, so there is nothing to refund.",
        exchange: {
          title: "Exchange your journey",
          subtitle:
            "Check the conditions and procedures for exchanging your train ticket, then proceed to modify your tickets covered by your social security.",
          tripToExchange: "Trip to exchange",
        },
        noExchange: {
          title: "Edit",
          text: "This route cannot be changed online. Please contact your travel agency",
          solution: "You can contact them, and an operator will assist you.",
          phoneNumber: "Phone Number",
          workingHours: "Working Hours",
        },
        warning: {
          title: "Warning - Edit in progress",
          text: "You are currently editing your train ticket. If you leave this page, you will lose your progress. Do you really want to abandon your changes ?",
          confirm: "Confirm",
          cancel: "Cancel",
        },
      },
      results: {
        availableOffers: "Available offers",
        confirmTravel: "Select this route",
        fareConditions: "fare conditions",
        secondClass: "2nd",
        firstClass: "1st",
        secondClassLong: "Second",
        firstClassLong: "First",
        unavailable: "Unavailable",
        startingFrom: "Starting from",
        hourAbbreviation: "h",
        dayAbbreviation: "d",
        connections: "Connections",
        returnList: "Back to list",
        previousTrains: "Show previous trains",
        previousFlights: "Show previous flights",
        nextTrains: "Show next trains",
        nextFlights: "Show next flights",
        sortAndFilter: "Sort and filter",
        seeDetails: "See details",
        seeLess: "See less",
        FULL_FLEX: "Full-flex",
        NO_FLEX: "No-Flex",
        SEMI_FLEX: "Semi-Flex",
        UNSPECIFIED: "",
        flexibility: "Flexibility",
        directConnection: "Direct journey",
        connectionsLong: "Connections",
        sortBy: "Sort by",
        price: "Price",
        time: "Time",
        duration: "Duration",
        lowestEmissions: "Lowest emissions",
        coveredAmount: "Covered amount",
        initialPrice: "Initial price",
        economy: "Eco.",
        economyPremium: "Eco. premium",
        business: "Business",
        noSolutions:
          "No {{transport}} is available for the moment.<br/>Please modify your search criteria and choose a specific station or airport. If the problem persists, please contact your travel agency for assistance.",
        agencyInfos:
          "Phone number: {{phone}}<br/>Business hours: {{openHours}}",
        freePlacement: "Free placement",
        coach: "Coach",
        seat: "Seat",
        offlineText: "Selected fare is not allowed by your caisse.",
        priceDifference: "Price difference",
        exchangeFees: "Exchange fees",
      },
      recap: {
        modifyTravel: "Modify this route",
        addToCart: "Add to cart",
        processingTitle: "Adding to cart",
        processingText:
          "This can take up to a few minutes. Please do not close, reload or navigate away from this page until it is done.",
        dueAfterCoverage: "Amount due after coverage",
        optionOuigo: "Additional options",
      },
      cart: {
        routeOf: "Route of",
        toThe: "to the",
        guaranteedUpTo: "Guaranteed up to",
        hoursMinutesSeparator: "h",
        deleteTravel: "Delete this trip",
        myCart: "My cart",
        emptyCart: "Empty cart",
        addTrip: "Add trip",
        payTrip: "Pay for this trip",
        confirmTrip: "Confirm this trip",
        outward: "Outward",
        return: "Return",
        to: "to",
        totalTravel: "Total travel",
        initialPrice: "Initial price",
        coveredAmount: "Covered amount",
        agencyFees: "Agency fees",
        noItems: "Your cart is empty",
        deleteConfirmation: "Are you sure you want to empty your cart?",
        releaseConfirmation:
          "Are you sure you want to remove this journey from your cart?",
      },
      confirmation: {
        title: "Confirmation",
        exchangeTitle: "Exchange confirmation",
        paymentTitle: "Payment confirmation",
        successMessage: "Your booking has been successfully completed",
        exchangeSuccessMessage:
          "Success: Your journey has been changed. The new tickets will be sent to you by e-mail.",
        paymentSuccessMessage:
          "Success: Your payment has been successfully processed. You will receive a confirmation email for your trip within a few minutes.",
        errorMessage:
          "An error occurred and your booking could not be completed. Please try again. If the error persists, please contact your travel agency.",
        backHome: "Back to home page",
        errorTitle: "Error",
        confirmBooking: "Confirm booking",
        viewBookings: "View my bookings",
        bookNewTrip: "Book a new trip",
      },
      travelStatus: {
        UNSPECIFIED: "Unspecified",
        PRE_BOOKED: "Pre-booked",
        BOOKED: "Booked",
        UPCOMING: "Upcoming",
        IN_PROGRESS: "In Progress",
        BOOKING_IN_PROGRESS: "Booking in Progress",
        COMPLETED: "Completed",
        CANCELLED: "Cancelled",
        UNKNOWN_STATUS: "Unknown Status",
      },
      status: "Status",
      active: "Active",
      inactive: "Inactive",
      conform: "Conform",
      notConform: "Not conform",
      number: "Number",
      email: "Email",
      lastName: "Last Name",
      firstName: "First Name",
      name: "Name",
      creationDate: "Creation date",
      caisseId: "Caisse",
      associatedCaisses: "Associated Caisses",
      billingClientName: "Client name to be billed The Treep",
      treepRecapPhoneNumber: "Phone number on Treep recap",
      outOfPocketExpense: "Out of pocket expense",
      treepRecap: "Treep Recap",
      contactEmail: "Contact Email",
      logo: "Logo",
      instanceUrl: "Instance URL",
      type: "Type",
      tauxPec: "Taux PEC",
      origin: "Origin",
      destination: "Destination",
      transportations: "Transport type",
      companions: "Companions",
      maxJourneys: "Maximum journeys",
      journeysBooked: "Booked journeys",
      trainCabinClass: "Train cabin class",
      planeCabinClass: "Plane cabin class",
      comments: "Comments",
      error: "Error",
      train: "Train",
      plane: "Plane",
      boat: "Boat",
      unspecified: "Unspecified",
      all: "All",
      import: "Import",
      ok: "Ok",
      back: "Back",
      class: {
        first: "First",
        second: "Second",
        business: "Business",
        economypremium: "Economy premium",
        economy: "Economy",
      },
      edit: "Edit",
      modify: "Modify",
      save: "Save",
      online: "online",
      offline: "offline",
      details: "View details",
      comment: "Comment",
      userBookings: {
        title: "My bookings",
        currentTravels: "Current travels",
        pastTravels: "Past travels",
        noCurrentTravels: "You have no current travels",
        noPastTravels: "You have no past travels",
        place: "Place",
        status: "Status",
        dates: "Dates",
        exchangeRequest: "Select travel to exchange",
        exchangeOutward: "Exchange outward",
        exchangeInward: "Exchange inward",
        fixedChangeFee: "Fixed change fee",
        variableChangeFee: "Variable change fee",
        changeableUntil: "Changeable until {{date}}",
        cancel: "Cancel",
        cancellation: "Cancellation",
        sucessfulCancellation: "Your travel has been cancelled",
        errors: {
          cancellation:
            "The cancellation of this trip is not possible online. Please contact your travel agency <strong>{{agency}}</strong> so that an operator can assist you.\n\nPhone number:\n<strong>{{phone}}</strong>\nBusiness hours: <strong>{{hours}}</strong>",
        },
        offlineTitle: "Edit",
        offlineText:
          "The total cost of your exchange (exchange fee + new ticket) is less than the original price of your ticket. This type of modification is not possible online. ",
        offlineText1:
          "Please contact your travel agency <strong>{{agencyName}}<strong> to finalize your request. You can contact them and an operator will assist you.",
        offlinePhoneNumber: "Phone number",
        openHour: "Working Hours",
        offlineClose: "Close",
        offlineBackToHome: "Back to Home",
        paidPrice: "Paid price",
        refundPrice: "Refund price",
        initialPrice: "Initial price",
        amountCovered: "Amount covered",
        agencyFees: "Agency fees",
        refundPriceToCaisse: "Amount refunded to the caisse",
        refundedTotal: "Total refunded",
        customerRefundFailed:
          "Your trip has been cancelled but your payment could not be refunded. Please contact your agency {{agency}} at {{phone}} ({{hours}}) to get your refund.",
      },
      user: {
        role: {
          admin: "Admin",
          travelAgent: "Travel Agent",
          caisseAssociate: "Caisse Associate",
          user: "User",
          createUser: "Add a user",
        },
      },
      settings: {
        gdpr: {
          title: "Terms and Conditions",
          cguAccessText: "Access",
          cguAccessLink: "Terms and Conditions",
          deleteAccount: "Delete my account",
          deleteAccountConfirmation: {
            title: "Delete my account",
            text: "Are you sure you want to delete your account? This action cannot be undone.",
            confirm: "Confirm",
            cancel: "Cancel",
          },
          deleteAccountSuccess: "Your account has been deleted.",
          forgetMe:
            "I am deleting my account and exercising my right to be forgotten",
        },
      },
      role: "Role",
      confirm: "Confirm",
      cancel: "Cancel",
      agency: "Agency",
      caisse: "Caisse",
      caisses: "Caisses",
      form: {
        fieldRequired: "Field required",
        email: {
          placeholder: "example@domain.com",
          invalid: "Email is invalid",
          required: "Email is required",
        },
        firstName: {
          placeholder: "Your first name here",
          required: "First name is required",
        },
        lastName: {
          placeholder: "Enter your last name",
          required: "Last name is required",
        },
        agency: {
          required: "Agency is required",
        },
        caisses: {
          required: "At least a caisse is required",
        },
        phone: {
          required: "Phone number is required",
          invalid: "Phone number is invalid",
        },
        departureDate: {
          required: "Departure date is required",
        },
        returnDate: {
          required: "Return date is required",
          minGap: "Return must be at least 1 hour after departure",
        },
        origin: {
          required: "Please select a departure location",
        },
        birthDate: {
          placeholder: "DD/MM/YYYY",
          required: "Birth date is required",
          invalid: "Birth date is invalid",
        },
        accreditation: {
          placeholder: "Enter your accreditation number",
          invalid: "Accreditation number is invalid",
        },
        gender: {
          label: "Gender",
          required: "Gender is required",
          male: "Male",
          female: "Female",
          nonBinary: "Non-binary",
        },
      },

      selectPlaceholder: "Select...",
      traits: {
        email: "Email",
        firstname: "First name",
        lastname: "Last name",
      },
      connect: "Connect",
      code: "Code",
      travel: "Travel",
      from: "From",
      to: "To",
      add: "Add",
      search: {
        travelFormInfos: {
          incorrectInfo:
            "Pre-filled departure and arrival information by your DAP. Have you noticed incorrect information? Please contact your agency.",
          moreLuggages:
            "If you want to add additional luggage, if you need a wheelchair transport or the addition of heavy equipment, if you need a surclassification or the addition of an additional seat on medical advice, please contact your travel agency to book your trip.",
          connections:
            "If you want to make connections taking into account different transport modes, please contact your travel agency to book your trip.",
        },
        originDestination: "Origin and destination",
        departureReturn: "Departure and return",
        passengers: "Passenger(s)",
        selectLocation: "Pick a location",
        destinationTooltip:
          "Information cannot be changed, the most relevant airport or station will be proposed",
        departureAt: "Departure at",
        returnAt: "Return at",
        leaveAt: "Leave at",
        arriveAt: "Arrive at",
        panelPlaceholder: "Click on a field to see options",
        search: "Search",
        passenger: {
          mainPassenger: "Beneficiary",
          info: "Have you found any incorrect information? Please contact your branch.The beneficiary is the person concerned by the DAP.",
          personalInfo: {
            heading: "Personal information",
            info: "Fields marked with an asterisk are required.",
          },
          name: "Name",
          lastname: "Last name",
          firstname: "First name",
          email: "Email",
          birthdate: "Birth date",
          phone: "Phone",
          residentCorsicaRate: "Resident Corsica rate",
          residentCorsicaRateLink: "Resident Corsica rate link",
          accreditationRequirement:
            "To benefit from these rates starting from March 1, 2021, you must have a valid accreditation number. It is assigned online after justifying a main and effective fiscal residence in Corsica. More information:",
          disability: {
            heading: "I have a disability",
            disability: "Disability",
            wheelchair: {
              type: "Wheelchair",
              dimensions: "Folded dimensions (in cm)",
              width: "Width",
              height: "Height",
              length: "Length",
              weight: "Weight (in kg)",
              wheelsThickness: "Wheels thickness (in cm)",
            },
            companion: {
              heading: "I am a companion",
              required: "Please select a companion type",
              placeholder: "Type of companion",
              unspecified: "Companion (non-guide)",
              disability_80_percent:
                "Reduced-rate PSH Guide: CMI disability or French disability card without mention, or with the mention « difficulty standing » or « white cane »",
              need_third_person:
                "Free PSH Guide - CMI invalidité or French disability card with the mention « besoin d'accompagnement » or « tierce personne » (except on international routes)",
              blindness_green_star:
                "Free PSH Guide for the Blind - CMI invalidité or French disability card with the mention « Cécité » or « Étoile verte » (except on international routes)",
            },
          },
          accreditation: "N° Accréditation",
          card: {
            heading: "Loyalty and discount card",
            add: "Add a travel card",
            edit: "Edit a travel card",
            type: {
              label: "Card type",
              required: "Card type required",
            },
            number: {
              label: "Card number",
              required: "Card number required",
            },
            effectiveDate: {
              label: "Effective date",
              required: "Effective date required",
            },

            expirationDate: {
              label: "Expiration date",
              required: "Expiration date required",
              minDate: "The card is expired",
            },
            checkboxConsent:
              "By checking this box, I agree that the information entered will be used for my trip.",
            privacyPolicyLink: "View our privacy policy",
            checkboxAccuracy:
              "By checking this box, I certify the accuracy of the data entered and I am responsible for the consequences of any incorrect entry.",
            expireAt: "Expires at",
            travelCard: "Travel card",
          },
          nonBinaryDisclaimer:
            "We fully respect your gender identity. However, some of our transportation partners require a binary selection (Male/Female) for administrative purposes.<br>In order to complete your booking, we kindly ask you to choose the option that suits you best. This selection is used solely for ticketing purposes and does not affect the recognition of your identity.<br>We understand that this may be inconvenient, and we continue to work with our partners to offer greater inclusivity in the future. Thank you for your understanding.",
        },
        additionalPassengers: {
          companions: "Companion(s)",
          info: "If the companions differ between the outward and return journeys, or if their travel dates differ from yours, please contact your travel agency to book your trip.",
          addCompanion: "Add a companion",
          editCompanion: "Edit a companion",
          maxCompanion: "({{number}} companions max.)",
          maxCompanionTooltip:
            "To add more than {{number}} companions, please contact your travel agency.",
        },
        outward: "Outward",
        return: "Return",
        errors: {
          moreOffers: "Could not get additional offers",
          overlapping: {
            title: "Existing booking detected",
            exact:
              "You already have a reservation for these dates.We recommend that you modify the dates of your search.\nIf needed, you can contact your travel agency <strong>{{agency}}</strong> to modify your existing booking or for any other specific request. You can contact them and an operator will assist you.\n\nPhone number: <strong>{{phone}}</strong>\nBusiness hours: <strong>{{hours}}</strong>",
            month:
              "You already have a trip booked during this period. We recommend checking your existing booking before making a new search.\nIf you wish to modify your trip or get more information, you can contact your travel agency <strong>{{agency}}</strong> and an operator will be available to assist you.\n\nPhone number: \n<strong>{{phone}}</strong>\nBusiness hours: <strong>{{hours}}</strong>\n\nYou may continue your search if you wish.",
            search: "Start search",
          },
        },
        moreMsg:
          "Best offers at public rate among all available offers. When selecting the return trip, if you have special fares (negotiated, NGO...) they will be available. You will also be able to choose among all the available offers (fare, flexibility, luggage).",
      },
      disability: "Disability",
      validate: "Validate",
      loader: {
        didYouKnow: "Did you know?",
        search: "We are looking for best itineraries for {{place}}...",
      },
      genericError: "An error occurred",

      product: {
        operatedBy: "Operated by",
        soldBy: "Sold by",
        connectionTime: "Connection time",
        cabinClass: "Class",
        numberShort: "No.",
      },
      home: {
        serviceTitle: "Health Journey Service",
        serviceDescription:
          "Have you received an agreement to cover transport for medical treatment? Assurance Maladie will take care of your travel by train, plane or boat. Follow the three steps below:",
        stepCreateAccount: "Create your account",
        stepConnected: "You are logged in",
        stepDescription1:
          "Click here to create your account, or log in if you already have one.",
        createAccountBtn: "Create my account",
        stepAuthNumber: "Enter your agreement number",
        numberValidated: "Number validated",
        stepDescription2:
          "Enter your agreement number and consult the details of your journey",
        findAuthNumberLink: "Where to find my coverage agreement number?",
        stepJourneyDetails: "Journey details",
        journeyConditionsIntro:
          "Below are the terms and conditions of your trip:",
        bookJourneyBtn: "Book my journey",
        facilitatedTransport: "Facilitated transport for healthcare",
        facilityDescription1:
          "You have received an agreement to cover the cost of transport for medical treatment? The Assurance Maladie makes it easy for you to book your train/plane ticket via its dedicated website, “Trajet santé de l'Assurance Maladie“ (TSAM).",
        facilityDescription2:
          "This service is reserved for policyholders attached to the health insurance funds of the following departments: Charente Maritime, Finistère, Corse du sud, Haute Corse, Martinique, Guadeloupe, Guyane Reunion, Mayotte, Var, Gard, Aquitaine, Loire-Atlantique.",
        bookYourJourney: "Book your journey",
        simpleQuickEconomical: "Simple, quick and economical",
        simpleDescription1:
          "Book your ticket easily, at least 7 days in advance, directly on this website or by phone (Monday to Friday, 9am to 6.30pm, mainland France time / 4am to 1.30pm in French Guiana / 3am to 12.30pm in the West Indies / 11am to 8.30pm in Reunion and Mayotte).\n📞 Call not surcharged (cost of a local call). Don't forget to bring your agreement number with you when booking.",
        simpleDescription2:
          "You receive your ticket by email or mail. You don't pay for your ticket or only a portion of it depending on the coverage rate",
        faqTitle: "Frequently Asked Questions",
        findDapModalTitle: "Where to find my agreement number?",
        findDapModalDescription:
          "You can find your agreement number in the letter sent by the Health Insurance:",
        findDapModalImageAlt: "Example of agreement number",
        allAnswersInFAQ: "All answers in our FAQ",
        helpVideoTitle: "Are you having difficulties?",
        helpVideoDescription:
          "A help video is available to guide you through using the platform.",
        helpVideoLink: "Watch the help video",
      },
      validation: {
        required: "This field is required",
      },
      options: {
        ouigoflexText:
          "Exchange your ticket free of charge up to 30 minutes before your train departure",
        seeConditions: "See conditions",
        ouigiflexAdult: "{{price}}/ Adult",
        ouigiflexChild: "Free for children",
        luggage: "Additional luggage",
        luggageDimensions: "Max dimensions 1.3 x 1.3 and 30kg",
        luggageMaximum: "{{price}}/bag, maximum {{max}}",
        luggageWarning:
          "Book your additional luggage now. Any unreserved luggage will be charged €20 during platform control.",
        foldedBike: "Folded or dismantled bike in a cover",
        foldedBikeDimensions: "Max dimensions 130 x 90 and 30kg",
        foldedBikeMaximum: "{{price}}/bike, maximum {{max}}",
        nonFoldedBike: "Non-dismantled bike",
        nonFoldedBikeWarning:
          "Excluding recumbent bikes, tricycles, tandems and trailers.",
        nonFoldedBikeMaximum: "{{price}}/bike, maximum {{max}}",
        additionalCost: "Additional cost: {{cost}}",
        next: "Next",
        passenger: "Passenger",
      },
      exchange: {
        exchange: "Exchange",
        newTravel: "New travel",
        toPay: "Amount to pay",
        priceDifference: "Price difference",
        exchangeFees: "Exchange fees",
        agencyFees: "Agency fees",
        confirm: "Confirm exchange",
        searchForm: {
          departure: "Departure",
        },
      },
      satisfaction: {
        title: "Give us your opinion on Trajet Santé Assurance Maladie",
        button: "Answer the questionnaire",
      },
      placement: {
        title: "Placement",
        noPreference: "No preference",
        nextRelatives: "Travelling next to a companion",
        trainPlan: "Choose on the train map",
        preference: "Set preferences",
        carNumber: "Coach number",
        placeNumber: "Seat number",
        chooseSeat: "Choose a seat",
        upperDeck: "Upper deck",
        lowerDeck: "Lower deck",
        seat: "Seat",
        next: "Next",
        confirm: "Confirm",
        edit: "Edit",
        spaceType: "Space type",
        seatDeck: " Seat deck",
        seatPosition: "Seat position",
        searchError: "Placement wish not available",
      },
      contact: {
        title: "Contact",
        description:
          "Don't forget to check the ‘My reservations’ section of your personal space regularly to track the status of your requests.",
        help: "If you can't find the answer to your question on our Help page, please contact your local branch.",
        selectCaisse: "Select your caisse",
        phoneTitle: "By phone",
        phoneDescription:
          "Call your agency <strong>{{agencyName}}</strong> at {{phoneNumber}}{{openHours}}",
        chatTitle: "By chat",
        chatDescription:
          "Ask an agent all your questions <strong>{{agencyName}}</strong> by clicking on the chat at the bottom right of each page",
        emailTitle: "By email",
        emailDescription: "By sending an email to <strong>{{email}}</strong>",
        error:
          "Your health insurance fund has not subscribed to the Trajet Santé online service.",
        noConnected: "Please log in to access this page",
      },
      faq: {
        title: "Help",
        subtitle:
          "You will find below the general rules on the reimbursement of transport costs",
        questions: [
          {
            question: "What are the terms and conditions?",
            answer: `To book your tickets for transport (train, plane, boat in certain regions) covered by the Assurance Maladie via the dedicated **Service Trajet Santé de l'Assurance Maladie** platform, you must have received a letter from your CPAM/CGSS explaining the procedure. This notification includes an agreement number enabling you to book your tickets online.`,
          },
          {
            question: "What transport is provided on site?",
            answer: `Whether you are traveling alone or with a companion, your doctor may prescribe transport by **plane, boat or train**.
* For journeys by **plane, boat or train of more than 150 km**, an agreement is required.
* The **agreement number** is indicated on your notification, enabling you to book your ticket via the **Service Trajet Santé de l'Assurance Maladie**.
        `,
          },
          {
            question: "Which means of transport can I book?",
            answer: `Via the **Service Trajet Santé de l'Assurance Maladie** you can book the following modes of transport:
<br><br>
* **Train and plane**: online or by phone.
* **Boat**: only by phone.
        `,
          },
          {
            question: "What do I need to book a ticket?",
            answer: `Your letter of agreement from your CPAM/CGSS, indicating your **agreement number**.`,
          },
          {
            question: "Is my ticket fully covered?",
            answer: `When you use the **Service Trajet Santé de l'Assurance Maladie**, you don't pay for your ticket, or only part of it, depending on the rate of reimbursement applicable to your transport. Your mutual insurance company may reimburse the remainder.
| Ticket price | Coverage rate | Covered by the Assurance Maladie | Amount to pay |
|-------------------|-------------------------|----------------------------------------|-----------------|
| 100 €             | 100%                    | 100 €                                  | 0 €             |
| 100 €             | 55%                     | 55 €                                   | 45 €            |`,
          },
          {
            question: "What are the coverage criteria?",
            answer: `Your agreement letter specifies :

* The means of transport prescribed.
* The number of trips.
* The destination.
* The rate of reimbursement (55% or 100%).
* Specific conditions (accompanying person, 1ᵉ class, boat cabin).

**Not covered:**

* Personal options (meals, luxury cabin...)`,
          },
          {
            question: "Coverage of additional transport",
            answer:
              "If you need to use a **taxi conventionné or public transport**, you can request reimbursement via the service [Mes Remboursements Simplifiés](https://www.mrs.beta.gouv.fr/). Your doctor will provide you with a medical prescription authorizing coverage of these types of transportation.",
          },
          {
            question: "Can I book everything online?",
            answer: `Yes, you will be guided. You can book your tickets **return by train or plane**. In certain cases, you will need to contact a consultant at your agency via the [Contact page](/admin/contact): 

* **Special requests**.
* **Single trip (one way only)**.
* **Boat reservation**.`,
          },
          {
            question: "How do I get a ticket?",
            answer: `1. I log in to the site.
2. Enter my agreement number.
3. I fill in the passenger(s) information.
4. I search for my ticket.
5. I book my round trip.
6. I pay the remaining cost of my ticket if applicable.
7. I receive my tickets by e-mail.`,
          },
          {
            question: "First connection?",
            answer: `* **Register** by clicking on “Registration”.
* Fill in the information requested (identical to that on your CPAM/CGSS letter).
* Click on the validation link received by e-mail.
* If you don't receive anything, check your **SPAM**.`,
          },
          {
            question: "Already registered?",
            answer: `* **Login** with your e-mail address and password.
* If you forget your password, click on **"Forgot your password?”** and follow the instructions.           
            `,
          },
          {
            question: "Need help?",
            answer: `Go to the [Contact page](/admin/contact).`,
          },
        ],
      },
      passport: {
        heading: "Passenger {{index}} passport",
        mandatoryFields: "Fields marked with an asterisk are required.",
        number: "Passport number",
        numberPlaceholder: "Enter your passport number",
        issueDate: "Issue date",
        issueDatePlaceholder: "Enter your issue date",
        expiryDate: "Expiry date",
        expiryDatePlaceholder: "Enter your expiry date",
        countryOfIssue: "Country of issue",
        countryPlaceholder: "Pick your country of issue",
        validation: {
          expiryDateMustBeAfterIssueDate:
            "The expiry date must be after the issue date",
          expiryDateMustBeInTheFuture: "The expiry date must be in the future",
        },
      },
      cookies: {
        title: "🍪 Cookie management",
        body: "This site uses a strictly necessary cookie to enable the online messaging service. No data is collected for publicity or statistics purposes.",
      },
    },
  },
};

export default translations;
